import { StatsData } from "../../types/Signup/SignUpStep";

export default function Stats({ data }: { data: StatsData }) {
  return (
    <div className="mx-auto hidden md:block">
      <dl className="grid grid-cols-2 items-stretch py-12 border-t doctio-grey-border gap-x-3 text-center lg:grid-cols-3">
        <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
          <dt className="text-center text-dbase text-doctio-green font-medium">
            Læger
          </dt>
          <h3 className="order-first text-center text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
            {data.doctor}
          </h3>
        </div>
        <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
          <dt className="text-center text-dbase text-doctio-green font-medium">
            Lægestuderende
          </dt>
          <h3 className="order-first text-center text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
            {data.medstudent}
          </h3>
        </div>
        <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
          <dt className="text-center text-dbase text-doctio-green font-medium">
            Sygeplejesker
          </dt>
          <h3 className="order-first text-center text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
            {data.nurse}
          </h3>
        </div>
      </dl>
    </div>
  );
}
